export enum AbTestEnum {
  AddonsTest_vA = 'AddonsTest_vA',
  AddonsTest_vD = 'AddonsTest_vD',
  CepikReturnToTheFirstScreen = 'CepikReturnToTheFirstScreen',
  MerchCapTkUpsell = 'checkout_upsell_merch_cap_tk_v1',
  OCOfferWithUpgradeToAC = 'OCOfferWithUpgradeToAC',
  OfferBoxV6 = 'enhancedRankingDetailsForAcAss_v6',
  PaymentMethodOnInstallments = 'paymentMethodTest',
  RenewalOffer = 'renewal_offer',
  TrastiRenewal = 'trastiRenewal',
  TravelChooseOfferClickTestV2 = 'CTA_ChooseOffer_Click_Test_v2',
  TravelNewRecommendationEngine = 'new_reko_engine',
}
